import React, { Component } from 'react';
import { connect } from 'react-redux';
import { api } from 'api';
import { Button, Card, CardHeader, CardBody, Row, Col, CustomInput, FormGroup, Input, Label, FormFeedback, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

class RolesEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roleConfig: {
                role: '',
                name: '',
                permissions: {},
                settings: {}
            },
            roleOptions: [],
            isEdit: false,
            loading: true,
            saving: false
        };
    }

    componentDidMount() {
        this.loadSystemRoles();
        const { match } = this.props;
        if (match.params.id) {
            this.loadRole(match.params.id);
        } else {
            // Create mode
            this.setState({ loading: false, isEdit: false });
        }
    }

    loadSystemRoles = async () => {
        try {
            const response = await api.get("system-roles", { page_size: 1000 });
            const data = Array.isArray(response) ? response : (response.results || []);
            this.setState({ roleOptions: data.map(role => ({ label: role.name, value: role.id })) });
        } catch (e) {
            console.error(e);
        }
    }

    loadRole = async (id) => {
        try {
            const response = await api.get(`roles/${id}`);
            this.setState({ roleConfig: response, loading: false, isEdit: true });
        } catch (error) {
            console.error(error);
            this.setState({ loading: false });
        }
    };

    handleInputChange = (field, value) => {
        const { roleConfig } = this.state;
        this.setState({
            roleConfig: {
                ...roleConfig,
                [field]: value
            }
        });
    }

    handlePermissionChange = (view, action, value) => {
        const { roleConfig } = this.state;
        const newPermissions = { ...roleConfig.permissions };

        if (!newPermissions[view]) {
            newPermissions[view] = {};
        }
        newPermissions[view][action] = value;

        this.setState({
            roleConfig: {
                ...roleConfig,
                permissions: newPermissions
            }
        });
    };

    handleSettingChange = (setting, value) => {
        const { roleConfig } = this.state;
        const newSettings = { ...(roleConfig.settings || {}) };
        newSettings[setting] = value;

        this.setState({
            roleConfig: {
                ...roleConfig,
                settings: newSettings
            }
        });
    };

    save = async () => {

        this.setState({ saving: true });

        const { roleConfig, isEdit } = this.state;

        try {

            const payload = {
                name: roleConfig.name,
                permissions: roleConfig.permissions,
                settings: roleConfig.settings,
                active: roleConfig.active,
            };

            // NUEVO SISTEMA
            if (roleConfig.system_role) {
                payload.system_role = roleConfig.system_role.id;
            }

            // LEGACY
            if (roleConfig.role !== undefined && roleConfig.role !== null) {
                payload.role = roleConfig.role;
            }

            if (isEdit) {
                await api.put(`roles/${roleConfig.id}`, payload);
            } else {
                await api.post(`roles`, payload);
            }

            Swal.fire({
                title: 'Guardado',
                text: 'Configuración guardada correctamente',
                icon: 'success',
                confirmButtonText: 'Aceptar'
            }).then(() => {
                this.props.history.push('/roles');
            });

        } catch (error) {

            console.error(error);

            Swal.fire({
                title: 'Error',
                text: 'Error guardando configuración.',
                icon: 'error',
                confirmButtonText: 'Cerrar'
            });

            this.setState({ saving: false });
        }
    };

    render() {
        const { roleConfig, loading, saving, isEdit, roleOptions } = this.state;

        if (loading) return <div className="p-4">Cargando...</div>;

        return (
            <div className="container mt-4 pb-5">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h2>{isEdit ? `Editar Rol: ${roleConfig.name}` : 'Crear Nuevo Rol'}</h2>
                    </div>
                    <div>
                        <Link to="/roles" className="btn btn-secondary mr-2">Cancelar</Link>
                        <Button color="primary" onClick={this.save} disabled={saving}>
                            {saving ? 'Guardando...' : 'Guardar Cambios'}
                        </Button>
                    </div>
                </div>

                <Row>
                    <Col md={12}>
                        <Card className="mb-4">
                            <CardHeader className="bg-light font-weight-bold">Información Básica</CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>Nombre del Rol</Label>
                                            <Input
                                                type="text"
                                                value={roleConfig.name || ''}
                                                onChange={(e) => this.handleInputChange('name', e.target.value)}
                                                placeholder="Ej. Paramédico"
                                            />
                                            <small className="form-text text-muted">
                                                Ej. Paramédico. Nombre identificativo único para esta configuración.
                                            </small>
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>Tipo de Rol (Sistema)</Label>
                                            <Input
                                                type="select"
                                                value={roleConfig.role}
                                                onChange={(e) => this.handleInputChange('role', parseInt(e.target.value))}
                                                disabled={isEdit}
                                            >
                                                <option value="">Seleccione un tipo...</option>
                                                {roleOptions.map(opt => (
                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                ))}
                                            </Input>
                                            <small className="form-text text-muted">
                                                Determina el nivel de acceso base en el sistema.
                                            </small>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col md={12}>
                        <Card className="mb-4">
                            <CardHeader className="bg-light font-weight-bold">Permisos de Vistas</CardHeader>
                            <CardBody>
                                <Table striped bordered hover responsive ref={this.tableRef}>
                                    <thead>
                                        <tr>
                                            <th>Módulo</th>
                                            <th className="text-center">Ver</th>
                                            <th className="text-center">Crear</th>
                                            <th className="text-center">Editar</th>
                                            <th className="text-center">Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[
                                            { key: 'emergencies', label: 'Emergencias' },
                                            { key: 'vehicles', label: 'Vehículos' },
                                            { key: 'users', label: 'Usuarios' },
                                            { key: 'stations', label: 'Estaciones' },
                                            { key: 'reports', label: 'Reportes', hideArgs: ['create', 'edit', 'delete'] },
                                            { key: 'roles', label: 'Roles', hideArgs: ['create', 'delete'] },
                                            { key: 'emergency_types', label: 'Tipos Emergencia' },
                                            { key: 'vehicle_types', label: 'Tipos Vehículo' },
                                            { key: 'qr_scan', label: 'Escaneo QR' },
                                        ].map(module => (
                                            <tr key={module.key}>
                                                <td className="font-weight-bold">{module.label}</td>
                                                <td className="text-center">
                                                    {this.renderTableSwitch(module.key, 'view')}
                                                </td>
                                                <td className="text-center">
                                                    {(!module.hideArgs || !module.hideArgs.includes('create')) && this.renderTableSwitch(module.key, 'create')}
                                                </td>
                                                <td className="text-center">
                                                    {(!module.hideArgs || !module.hideArgs.includes('edit')) && this.renderTableSwitch(module.key, 'edit')}
                                                </td>
                                                <td className="text-center">
                                                    {(!module.hideArgs || !module.hideArgs.includes('delete')) && this.renderTableSwitch(module.key, 'delete')}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col md={12}>
                        <Card className="mb-4">
                            <CardHeader className="bg-light font-weight-bold">Configuración Específica</CardHeader>
                            <CardBody>
                                {roleConfig.role === 8 ? (
                                    <React.Fragment>
                                        <div className="p-3 border-bottom d-flex justify-content-between align-items-center hover-bg-light" onClick={() => this.handleSettingChange('simple_form', !(roleConfig.settings && roleConfig.settings.simple_form))} style={{ cursor: 'pointer' }}>
                                            <div className="flex-grow-1 pr-3">
                                                <h6 className="mb-0 font-weight-bold text-dark">
                                                    Usar Formulario Simplificado (Modo Cabina)
                                                </h6>
                                                <small className="text-muted">
                                                    Si se activa, la creación de emergencias usará el modo simplificado (ocultando detalles complejos de vehículos por defecto). Ideal para operadores de cabina.
                                                </small>
                                            </div>
                                            <div onClick={(e) => e.stopPropagation()}>
                                                <CustomInput
                                                    type="switch"
                                                    id="simple_form"
                                                    label=""
                                                    checked={roleConfig.settings && roleConfig.settings.simple_form === true}
                                                    onChange={(e) => this.handleSettingChange('simple_form', e.target.checked)}
                                                />
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ) : (
                                    <div className="text-center text-muted p-3">
                                        No hay configuraciones específicas disponibles para el tipo de rol seleccionado.
                                    </div>
                                )}

                                <div className="p-3 d-flex justify-content-between align-items-center hover-bg-light" onClick={() => this.handleSettingChange('show_all_stations', !(roleConfig.settings && roleConfig.settings.show_all_stations))} style={{ cursor: 'pointer' }}>
                                    <div className="flex-grow-1 pr-3">
                                        <h6 className="mb-0 font-weight-bold text-dark">
                                            Ver todas las estaciones
                                        </h6>
                                        <small className="text-muted">
                                            Permite ver datos de todas las estaciones ignorando el filtro de estación del usuario. Útil para supervisores regionales.
                                        </small>
                                    </div>
                                    <div onClick={(e) => e.stopPropagation()}>
                                        <CustomInput
                                            type="switch"
                                            id="show_all_stations"
                                            label=""
                                            checked={roleConfig.settings && roleConfig.settings.show_all_stations === true}
                                            onChange={(e) => this.handleSettingChange('show_all_stations', e.target.checked)}
                                        />
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }

    renderTableSwitch = (view, action) => {
        const { roleConfig } = this.state;
        const checked = roleConfig.permissions[view] && roleConfig.permissions[view][action] === true;
        const id = `${view}-${action}`;

        return (
            <CustomInput
                type="switch"
                id={id}
                label=""
                checked={checked}
                onChange={(e) => this.handlePermissionChange(view, action, e.target.checked)}
                className="d-inline-block"
            />
        );
    };

}

export default connect()(RolesEdit);
